var _path, _path2, _path3, _path4, _path5, _path6, _path7, _tspan, _tspan2, _tspan3, _path8, _tspan4, _path9, _tspan5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLineWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.419 19.869",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.0000024045,
    y: -0.002197,
    width: 12.419,
    height: 12.419,
    rx: 1.8797,
    ry: 1.8797,
    fill: "#fff",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.9135 8.648-7.4039-2.4423",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.3688 1.7749-4.8592 4.4307",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.3005 4.9306-4.0597 5.7047",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.9135 8.648-2.6089-3.7217",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.3005 10.263c-.20817-.5898-.85133-.90104-1.4366-.69528-.58522.20579-.89091.85067-.68268 1.4405.20818.5898.85133.90104 1.4366.69531.58526-.2058.89091-.85067.68271-1.4405z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m8.3602 4.558c-.20815-.5898-.85133-.90104-1.4366-.69528-.58523.20579-.89091.85067-.68276 1.4405.20815.5898.85133.90104 1.4366.69531.58523-.2058.89091-.85067.68276-1.4405z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m10.973 8.2754c-.20815-.58983-.85133-.90104-1.4366-.69531-.58523.20577-.89091.85067-.68276 1.4405.20815.58978.85133.90104 1.4366.69528.58523-.20579.89091-.85067.68276-1.4404z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 3.0458386,
    y: 11.005163,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.0675px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 3.0458386,
    y: 11.005163,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    x: 7.0061965,
    y: 5.3068857,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.0675px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 7.0061965,
    y: 5.3068857,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    x: 9.6202478,
    y: 9.025774,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.0675px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 9.6202478,
    y: 9.025774,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "3"))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m3.5652 5.8289c-.20815-.58983-.85133-.90104-1.4366-.69531-.58523.20577-.89091.85067-.68276 1.4405.20815.58978.85133.90104 1.4366.69528.58523-.20579.89091-.85067.68276-1.4404z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 2.2122452,
    y: 6.5793037,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.0675px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 2.2122452,
    y: 6.5793037,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "4"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8.4244 1.4067c-.20815-.5898-.85133-.90104-1.4366-.69528-.58523.20579-.89091.85067-.68276 1.4405.20815.5898.85133.90104 1.4366.69531.58523-.2058.89091-.85067.68276-1.4405z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 7.0703902,
    y: 2.1555064,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.0675px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 7.0703902,
    y: 2.1555064,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "5"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.44 -145.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.65 165.66c1.3392 0 2.4247-1.0856 2.4247-2.4247 0-1.3391-1.0856-2.4247-2.4247-2.4247-1.3391 0-2.4247 1.0856-2.4247 2.4247 0 1.3392 1.0856 2.4247 2.4247 2.4247z",
    fill: "#d40000",
    strokeWidth: 0.12655
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.9 163.98 1.4949-1.509",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4783
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.39 163.98-1.4949-1.509",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4783
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineWrong);
export default __webpack_public_path__ + "static/media/icon_line_wrong.fb47b545bb16234aa4c6dbb394a47f85.svg";
export { ForwardRef as ReactComponent };